module.exports = __webpack_public_path__ + "img/FR16200.5f7c8f55.png";